import { useState,useRef } from "react";
import FilePreview from "../FilePreview";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import EditorViewer from "../../codesnippet/RTEEditorViewer";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CreateDeanAnnouncement = () => {
    const {id} = useParams()
    const navigate=useNavigate()
    const fileInputRef = useRef(null);
    const [announcement_type, setAnnouncementType] = useState("")
    const [file, setFile] = useState("")
    const [title,setTitle]=useState("")
    const [description,setDescription]=useState("")
    const [audience,setAudience]=useState("all")
    const [loading,setLoading]=useState(false) 
    const handleSubmit=async(e)=>{
          e.preventDefault()
          if(!announcement_type)
    {
        alert('announcement type is required')
        return;
    }
    if(!file)
    {
        alert('file is required')
        return;
    }
        const formData=new FormData()
        formData.append('name',title)
        formData.append('description',description)
        formData.append("audience",audience)
        formData.append('announcement_type',announcement_type)
        formData.append('file',file)

        try {
            setLoading(true)
           const res = await axios.post(
  `${BASE_URL}/marketplace/university/announcements/`,
   formData,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
  }
);
if (res && (res.status === 200 || res.status === 201)) 
{
    alert("Announcement created successfully")
    navigate(`/marketplace/${id}/dean/announcements`)
}
//  console.log("The response is:",res)

        } catch (error) {
            console.log('error while post request',error)
            toast.error(error.code)
            setLoading(false)
        }finally{
            setLoading(false)
        }
    }
    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl p-2 md:p-6">
                {/* Header */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                       <svg
  className="w-5 h-5 text-[#0f6abf]"
  fill="none"
  stroke="currentColor"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0"
  />
</svg>
                    </div>
                    <div>
                        <h2 className="text-lg font-semibold text-gray-900">Create New Announcement</h2>
                        <p className="text-sm text-gray-500 mt-0.5">Fill in the details below</p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4" encType="multipart/form-data">

                    {/* Project Title */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Title
                            </label>
                        </div>
                        <input
                            type="text"
                            name="title"
                            placeholder="Enter announcement title"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                            required
                            value={title}
                            onChange={(e)=>setTitle(e.target.value)}
                        />
                    </div>

                    {/* Publication Summary */}
                     {/* <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                            Summary (always visible)
                            </label>
                        </div>
                        <textarea
                            name="description"
                            rows="4"
                            placeholder="Short preview shown to everyone..."
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-y"
                            required
                            value={summary}
                            onChange={(e)=>setSummary(e.target.value)}
                        />
                    </div> */}
               {/* Publication Description */}
                                  <div>
                                                        <div className="flex items-center gap-2 mb-3">
                                                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                                                            <label className="text-sm font-semibold text-gray-700">
                                                            Description
                                                            </label>
                                                        </div>
                                                       
                                                        <div className="border border-gray-300 rounded-xl overflow-hidden">
                                                             <EditorViewer  code={false} readOnly={false} value={description} setValue={setDescription} />
                                                        </div>
                                                        
                                                    </div>
                    {/* Field */}
                    {/* <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Field of Interest
                            </label>
                        </div>
                        <input
                            type="text"
                            name="field"
                            placeholder="e.g., Artificial Intelligence"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                            required
                            value={field}
                            onChange={(e)=>setField(e.target.value)}
                        />
                    </div> */}

                    {/* Area */}
                    {/* <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Area of Interest
                            </label>
                        </div>
                        <input
                            type="text"
                            name="area"
                            placeholder="e.g., AI in Healthcare"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                            required
                            value={area}
                            onChange={(e)=>setArea(e.target.value)}
                        />
                    </div> */}

                    {/* Topic */}
                    {/* <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Topic of Interest
                            </label>
                        </div>
                        <input
                            type="text"
                            name="topic"
                            placeholder="e.g., Early disease detection using deep learning"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                            required
                            value={topic}
                            onChange={(e)=>setTopic(e.target.value)}
                        />
                    </div> */}
{/* Visibility Domain */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                               Announcement Target Audience
                            </label>
                        </div>
                        <select
                            name="type"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
                            style={{
                                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 16px center'
                            }}
                            value={audience}
                            onChange={(e)=>setAudience(e.target.value)}
                        >
                            {/* <option value="">Select Domain</option> */}
                            <option value="public">All</option>
                            <option value="private">Students</option>
                            <option value="restricted">Staff</option>
                        </select>
                    </div>
                    {/* Publication Type */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Announcement Type
                            </label>
                        </div>
                        <select
                            name="type"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
                            style={{
                                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 16px center'
                            }}
                            required
                            value={announcement_type}
                           onChange={(e) => {
  setAnnouncementType(e.target.value);
  setFile(null);
  if (fileInputRef.current) fileInputRef.current.value = "";
}}

                        >
                            <option value="">Select type</option>
                            <option value="pdf">PDF</option>
                            <option value="doc">DOC</option>
                            <option value="code">Code</option>
                            <option value="image">Image</option>
                            <option value="video">Video</option>
                            <option value="audio">Audio</option>
                        </select>
                    </div>

                    {/* Project Image */}
                    <div>
                        <div className="mt-6 flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700" htmlFor="projectImage">
                                Upload Announcement {announcement_type?.toUpperCase()}  File
                            </label>
                        </div>

                        {
                            file ? <>
                                <FilePreview publication_type={announcement_type} file={file} setFile={setFile} />

                            </> : <>
                                <label
                                    htmlFor="projectImage"
                                    className={`border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors cursor-pointer flex flex-col items-center ${announcement_type ? "" : "pointer-events-none opacity-50"}`}
                                >
                                    <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
                                        <svg
                                            className="w-5 h-5 text-[#0f6abf]"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                            />
                                        </svg>
                                    </div>

                                    <p className="text-sm text-gray-600">Click to upload publication file</p>
                                    <p className="text-xs text-gray-400 mt-1">JPG, PNG up to 5MB</p>
                                </label>

                                {/* Hidden input */}
                                <input
                                    type="file"
                                    id="projectImage"
                                    name="image"
                                    accept={
                                        announcement_type === "pdf"
                                            ? "application/pdf"
                                            : announcement_type === "doc"
                                                ? "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                : announcement_type === "image"
                                                    ? "image/*"
                                                    : announcement_type === "video"
                                                        ? "video/*"
                                                        : announcement_type === "audio"
                                                            ? "audio/*"
                                                            : announcement_type === "code"
                                                                ? ".js,.py,.java,.cpp,.c,.html,.css,.ts,.jsx,.tsx"
                                                                : "*/*" // fallback: allow all
                                    }
                                    className="hidden"
                                    required
                                    ref={fileInputRef}
                                    onChange={(e) => setFile(e.target.files[0])}
                                />
                            </>
                        }
                    </div>
                   {/* <div>
  <div className="mt-6 flex items-center gap-2 mb-3">
    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
    <label className="text-sm font-semibold text-gray-700" htmlFor="projectImages">
      Any Reference Files
    </label>
  </div>

  <label
    htmlFor="projectImages"
    className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors cursor-pointer flex flex-col items-center"
  >
    {referenceFiles && referenceFiles.length > 0 ? (
      <div className="flex flex-col items-center gap-2">
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
          <svg
            className="w-5 h-5 text-[#0f6abf]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <ul className="text-gray-700 list-disc list-inside">
          {Array.from(referenceFiles).map((file, index) => (
            <li key={index}>{file.name}</li>
          ))}
        </ul>
      </div>
    ) : (
      <>
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
          <svg
            className="w-5 h-5 text-[#0f6abf]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <p className="text-sm text-gray-600">Click to upload reference files</p>
        <p className="text-xs text-gray-400 mt-1">JPG, PNG up to 5MB</p>
      </>
    )}


    <input
      type="file"
      id="projectImages"
      name="image"
      accept="*"
      multiple
      className="hidden"
      onChange={(e) => setReferenceFiles(Array.from(e.target.files))}
    />
  </label>
</div> */}



                    {/* Submit */}
                <button
    type="submit"
    className="mt-12 w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
    disabled={loading}
>
    {loading ? (
        <>
            {/* Spinner loader */}
            <svg 
                className="animate-spin h-5 w-5 text-white" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24"
            >
                <circle 
                    className="opacity-25" 
                    cx="12" 
                    cy="12" 
                    r="10" 
                    stroke="currentColor" 
                    strokeWidth="4"
                ></circle>
                <path 
                    className="opacity-75" 
                    fill="currentColor" 
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
            Creating Announcement...
        </>
    ) : (
        <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Create Announcement
        </>
    )}
</button>
                </form>
            </div>
        </div>
    );
};

export default CreateDeanAnnouncement;